import { Component, Input, ChangeDetectionStrategy, OnInit, Output, EventEmitter } from '@angular/core';
import { StatusIndicatorInput, ButtonInput, LabelValueInput } from './list-card.components.types';

@Component({
  selector: 'app-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListCardComponent implements OnInit {
  /**
   * The title of the list card.
   */
  @Input() title: string | undefined;

  /**
   * The main text content of the list card.
   */
  @Input() bodyText: string | undefined;

  /**
   * An array of status indicators to display in the card.
   */
  @Input() statuses: StatusIndicatorInput[] = [];

  /**
   * An array of buttons to display in the card.
   */
  @Input() buttons: ButtonInput[] = [];

  /**
   * Disables buttons and checkbox/radio inputs
   */
  @Input() disabled = false;

  /**
   * An array of label-value pairs to display in the card.
   */
  @Input() labelValues: LabelValueInput[] = [];

  /**
   * Show checkbox on card.
   */
  @Input() showCheckbox = false;

  /**
   * Emits the value of the checkbox/radio select.
   */
  @Input() checkboxValue: boolean | undefined;

  @Output() checkboxValueChange = new EventEmitter<boolean>();

  ngOnInit() {
    if (this.buttons.length) {
      this.buttons = this.buttons.map((button) => this.createButtonInput(button));
    }

    if (this.statuses.length) {
      this.statuses = this.statuses.map((status) => this.createStatusInput(status));
    }

    if (this.labelValues.length) {
      this.labelValues = this.labelValues.map((item) => this.createLabelValueInput(item));
    }
  }

    valueChangeFunction() {
    this.checkboxValue = !this.checkboxValue;
    this.checkboxValueChange.emit(this.checkboxValue);
  }

  createButtonInput(input: ButtonInput): ButtonInput {
    return {
      label: input.label,
      variant: input.variant || 'primary',
      size: input.size || 'small',
      iconPosition: input.iconPosition || 'right',
      matStyle: input.matStyle || '',
      icon: input.icon || '',
      href: input.href || '',
      routerLink: input.routerLink || '',
      queryParams: input.queryParams || {},
      destructive: input.destructive ?? false,
      download: input.download ?? false,
      newWindow: input.newWindow ?? false,
      allowReferer: input.allowReferer ?? false,
      setAutofocus: input.setAutofocus ?? false,
      disabled: input.disabled ?? false,
      loading: input.loading ?? false,
      type: input.type || 'button',
      onClick: input.onClick
    };
  }

  createStatusInput(input: StatusIndicatorInput): StatusIndicatorInput {
    return {
      text: input.text,
      color: input.color || 'grey',
      icon: input.icon || null,
      variant: input.variant || 'subtle',
      matStyle: input.matStyle || '',
      appendix: input.appendix || '',
      link: input.link || '',
      linkText: input.linkText || ''
    };
  }

  createLabelValueInput(input: LabelValueInput): LabelValueInput {
    return {
      currency: input.currency || false,
      date: input.date || false,
      percent: input.percent || false,
      hiddenValue: input.hiddenValue || '',
      href: input.href || '',
      isError: input.isError || false,
      isLink: input.isLink || false,
      label: input.label || '',
      largeFormat: input.largeFormat || false,
      subValue: input.subValue || '',
      tooltipContent: input.tooltipContent || undefined,
      values: input.values || []
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  statusTrackByIndex(index: number, _status: StatusIndicatorInput): number {
    return index;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  buttonTrackByIndex(index: number, _button: ButtonInput): number {
    return index;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  labelValueTrackByIndex(index: number, _item: LabelValueInput): number {
    return index;
  }
}
